module.exports = __webpack_public_path__ + "static/media/circleplus.69b92027.svg";